"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriptychCard = exports.isArrayOfStrings = void 0;

var _react = _interopRequireDefault(require("react"));

var _Theme = require("../../../Theme");

var _v = require("./v2");

var _v2 = require("./v3");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var isArrayOfStrings = function isArrayOfStrings(images) {
  return _toConsumableArray(images).every(function (src) {
    return typeof src === "string";
  });
};
/**
 * `TriptychCard` is a card with a layout one square image on the left,
 * one tall or two square images on the right, and text for title and subtitle
 * at the bottom.
 */


exports.isArrayOfStrings = isArrayOfStrings;

var TriptychCard = function TriptychCard(props) {
  var Component = (0, _Theme.useThemeConfig)({
    v2: _v.TriptychCard,
    v3: _v2.TriptychCard
  });
  return /*#__PURE__*/_react.default.createElement(Component, props);
};

exports.TriptychCard = TriptychCard;
TriptychCard.displayName = "TriptychCard";
//# sourceMappingURL=TriptychCard.js.map